/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Feature Categories)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Default values and factories for Feature Categories forms.
────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

/**
 * Default form state
 */
export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  description: '',
  enabled: true,
};

/**
 * Get default form state
 */
export function getDefaultFormState(): FormState {
  return JSON.parse(JSON.stringify(DEFAULT_FORM_STATE));
}

